import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { AlertasService } from '../core/_services/alerta.service';
import { CoreService } from '../core/_services/core.services';
import { salarios } from '../core/_util/salarios';
import { motivosRetiro } from '../core/_util/motivoRetiro-utils';

@Component({
  selector: 'app-hoja-vida-candidato',
  templateUrl: './hoja-vida-candidato.component.html',
  styleUrls: ['./hoja-vida-candidato.component.scss']
})
export class HojaVidaCandidatoComponent implements OnInit {

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService
  ) {

  }

  nivelEstudios: any[] = [];
  datosBasicos: any = [];
  experiencias: any[] = [];
  estudios: any[] = [];
  grupoFamiliar: any[] = [];
  referenciasPersonales: any[] = [];
  redesSociales: any[] = [];

  listaTiposIdentificacion: any[] = [];
  listaGeneros: any[] = [];
  listaEstadosCiviles: any[] = [];
  listaAspiracionSalarial: any[] = [];
  listaEntidadesEPS: any[] = [];
  listaEntidadesAFP: any[] = [];
  listaClaseLibreta: any[] = [];
  listaTiposVehiculos: any[] = [];
  listaCategoriaLicencias: any[] = [];
  listaTipoRelacion: any[] = [];
  listaEscolaridades: any[] = [];
  listaParentesco: any[] = [];
  listaDisponiblesCompetencias: any[] = [];
  listaAsignadosCompetencias: any[] = [];
  listaDisponiblesConocimientos: any[] = [];
  listaAsignadosConocimientos: any[] = [];
  listaDisponiblesHabilidades: any[] = [];
  listaAsignadosHabilidades: any[] = [];

  listaSalario = salarios;
  listaMotivo = motivosRetiro;

  columnas : any[] = [];
  columnasCompetencias : any[] = [];
  columnasConocimientos : any[] = [];
  columnasHabilidades : any[] = [];
  items: any = [1, 1, 1, 1];
  cargando: boolean = true;

  idCandidato : any ;
  numero_candidato_id : any ;

  cargandoDatosBasicos : boolean = true;

  ngOnInit(): void {

      this.idCandidato = this.route.snapshot.params.idCandidato;
      this.numero_candidato_id = this.route.snapshot.params.numero_id;

    this.getCargarListas();
    this.getDatosBasicos();
    this.getListaNivelEstudios();
    this.getExperiencias();
    this.getEstudios();
    this.getGrupoFamiliar();
    this.getReferenciaPersolanes();
    this.getRedesSociales();
    this.getListaCompetencias();
    this.getListaConocimientos();
    this.getListaHabilidades();

    this.columnas = [
      { field: 'red_social', header: 'Red Social' },
      { field: 'usuario', header: 'Usuario' },
      { field: 'link_red', header: 'Link' },
    ];
    this.columnasCompetencias = [
      { header: 'Competencias', field: 'competencia' },
    ];
    this.columnasConocimientos = [
      { header: 'Conocimientos Específicos', field: 'conocimiento' },
    ];
    this.columnasHabilidades = [
      { header: 'Habilidades', field: 'habilidad' },
    ];
  }

  // GET DATOS
  getDatosBasicos() {

    let data ={
      candidato_id : this.idCandidato,
      numero_candidato_id: this.numero_candidato_id
    }
    this.coreService.getWithParams('/datos-basicos', data).subscribe(
      (res: any) => {
        this.datosBasicos = res;

        this.datosBasicos.tipo_id = res['tipo_id'] != null ? this.cargarParentesco(this.listaTiposIdentificacion, res['tipo_id'])?.descripcion : res['tipo_id'];
        this.datosBasicos.aspiracion_salarial = res['aspiracion_salarial'] != null ? this.cargarParentesco(this.listaAspiracionSalarial, res['aspiracion_salarial'])?.descripcion : res['aspiracion_salarial'];
        this.datosBasicos.entidad_eps = res['entidad_eps'] != null ? this.cargarParentesco(this.listaEntidadesEPS, res['entidad_eps'])?.descripcion : res['entidad_eps'];
        this.datosBasicos.entidad_afp = res['entidad_afp'] != null ? this.cargarParentesco(this.listaEntidadesAFP, res['entidad_afp'])?.descripcion : res['entidad_afp'];
        this.datosBasicos.genero = res['genero'] != null ? this.cargarParentesco(this.listaGeneros, res['genero']).descripcion : res['genero'];
        this.datosBasicos.estado_civil = res['estado_civil'] != null ? this.cargarParentesco(this.listaEstadosCiviles, res['estado_civil'])?.descripcion : res['estado_civil'];
        this.datosBasicos.clase_libreta = res['clase_libreta'] != null ? this.cargarParentesco(this.listaClaseLibreta, res['clase_libreta'])?.descripcion : res['clase_libreta'];
        this.datosBasicos.tipo_vehiculo = res['tipo_vehiculo'] != null ? this.cargarParentesco(this.listaTiposVehiculos, res['tipo_vehiculo'])?.descripcion : res['tipo_vehiculo'];
        this.datosBasicos.categoria_licencia = res['categoria_licencia'] != null ? this.cargarParentesco(this.listaCategoriaLicencias, res['categoria_licencia'])?.descripcion : res['categoria_licencia'];

        if(this.datosBasicos.foto != null){
          this.getImagenPerfil();
        }

        this.cargandoDatosBasicos = false;
      },
      (err: any) => {
        console.log(err);
      }
    );

  }

  getImagenPerfil(){

    let data ={
      candidato_id : this.idCandidato,
      numero_candidato_id: this.numero_candidato_id
    }
    this.coreService.download('/ver-foto-candidato/'+this.idCandidato+'/'+this.numero_candidato_id).subscribe(
      (res: any) => {
        if(res.body.type != 'application/json'){
          let blob = new Blob([res.body], { type: 'image/png' });
          let file = new File([blob], 'image/png', { type: 'image/png', lastModified: Date.now() });
          var fileURL = URL.createObjectURL(file);
          var img = new Image();
          img.style.width = "50%";
          img.style.height = "50%";
          img.style.clipPath = "inset(0px 25px 0px 25px)";

          img.id = "imagenUsuario";
          img.src = fileURL;

          var hijo = document.getElementById("fotoPerfil");
          document.getElementById('imagenPerfil').replaceChild( img,hijo);

        }

      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  getCargarListas() {

    var listas = ["tiposIdentificacion",
      "generos",
      "estadosCiviles",
      "aspiracionSalarial",
      "entidadesEPS",
      "entidadesAFP",
      "clasesLibretas",
      "tiposVehiculos",
      "categoriasLicencias",
      "tiposRelaciones",
      "escolaridades",
      "parentescos"
    ];

    listas.forEach(element => {

      this.coreService.get('/listas/' + element).subscribe(
        (res: any[]) => {
          if (element == listas[0]) {
            this.listaTiposIdentificacion = res;
          } else if (element == listas[1]) {
            this.listaGeneros = res;
          } else if (element == listas[2]) {
            this.listaEstadosCiviles = res;
          } else if (element == listas[3]) {
            this.listaAspiracionSalarial = res;
          } else if (element == listas[4]) {
            this.listaEntidadesEPS = res;
          } else if (element == listas[5]) {
            this.listaEntidadesAFP = res;
          } else if (element == listas[6]) {
            this.listaClaseLibreta = res;
          } else if (element == listas[7]) {
            this.listaTiposVehiculos = res;
          } else if (element == listas[8]) {
            this.listaCategoriaLicencias = res;
          } else if (element == listas[9]) {
            this.listaTipoRelacion = res;
          } else if (element == listas[10]) {
            this.listaEscolaridades = res;
          } else if (element == listas[11]) {
            this.listaParentesco = res;
          }
        },
        (err: any) => {
          console.log(err);
        }
      );
    });

  }

  cargarParentesco(iLista, valor) {
    if (iLista !== undefined && iLista != null) {
      for (let i = 0; i < iLista.length; i++) {
        if (iLista[i].id === valor || parseInt(iLista[i].value) === parseInt(valor)) {
          return iLista[i];
        }
      }
    }
  }

  getExperiencias() {
    let data ={
      candidato_id : this.idCandidato
    }
    this.coreService.getWithParams('/experiencias-ref', data).subscribe(
      (res: any) => {
        this.experiencias = res;
      },
      (err: any) => {
        if (err.error !== undefined && err.error !== null) {
          for (let index = 0; index < err.error.length; index++) {
            this.msj.error(err.error[index]);
          }
        }
      }
    )
  }

  labelSalario(id_salario) {
    let label = '';
    this.listaSalario.forEach(element => {
      if (element.value == id_salario) {
        label = element.label;
      }
    }
    );
    return label;
  }

  labelMotivoRetiro(id_motivo) {
    let label = '';
    this.listaMotivo.forEach(element => {
      if (element.value == id_motivo) {
        label = element.label;
      }
    }
    );
    return label;
  }

  getEstudios() {
    let data ={
      candidato_id : this.idCandidato
    }
    this.coreService.getWithParams('/estudios', data).subscribe(
      (res: any[]) => {
        this.estudios = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  labelNivel(nivel_id) {
    let label = '';
    if (this.nivelEstudios !== []) {
      this.nivelEstudios.forEach(element => {
        if (element.code === nivel_id) {
          label = element.name;
        }
      }
      );
    }
    return label;
  }

  getListaNivelEstudios() {
    let data ={
      candidato_id : this.idCandidato
    }
    this.coreService.getWithParams('/estudios-nivel', data).subscribe(

      (res: any[]) => {
        this.nivelEstudios = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  getGrupoFamiliar() {
    let data ={
      candidato_id : this.idCandidato
    }
    this.coreService.getWithParams('/grupo-familia', data).subscribe(

      (res: any[]) => {

        console.log(res);

        this.grupoFamiliar = res;

        this.grupoFamiliar.forEach((elemento) => {
          elemento.tipo_documento = this.cargarParentesco(this.listaTiposIdentificacion,  elemento.tipo_documento).descripcion;
          elemento.escolaridad_id = this.cargarParentesco(this.listaEscolaridades,  elemento.escolaridad_id).descripcion;
          elemento.parentesco_id = this.cargarParentesco(this.listaParentesco,  elemento.parentesco_id).descripcion;
          elemento.genero = this.cargarParentesco(this.listaGeneros,  elemento.genero).descripcion;
        });
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  getReferenciaPersolanes() {
    let data ={
      candidato_id : this.idCandidato
    }
    this.coreService.getWithParams('/referencia-personal', data).subscribe(

      (res: any[]) => {
        this.referenciasPersonales = res;

        for (let index = 0; index < this.referenciasPersonales.length; index++) {
          this.referenciasPersonales[index].tipo_relacion_id = this.cargarParentesco(this.listaTipoRelacion,  this.referenciasPersonales[index].tipo_relacion_id).descripcion;
        }
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  getRedesSociales() {
    let data ={
      candidato_id : this.idCandidato
    }
    this.coreService.getWithParams('/red-social', data).subscribe(
      (res: any) => {

        this.redesSociales =res;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  getListaCompetencias() {
    let data ={
      candidato_id : this.idCandidato
    }
    this.coreService.getWithParams('/index-competencias', data).subscribe(
      (res: any) => {
        this.listaAsignadosCompetencias = res.registros_seleccionados;
        let disponibles = res.listaTotal;
        disponibles.forEach((item, index) => {
          this.listaAsignadosCompetencias.forEach((i) => {
            if (i.des_referencia === item.des_referencia) {
              disponibles.splice(index, 1);
            }
          })
        });
        this.listaDisponiblesCompetencias = disponibles;
      },
      (err: any) => {
      }
    )
  }

  getListaConocimientos() {
    let data ={
      candidato_id : this.idCandidato
    }
    this.coreService.getWithParams('/index-conocimientos', data).subscribe(
      (res: any) => {
        // this.listaAsignadosOrig = res.listaTotal;
        this.listaAsignadosConocimientos = res.registros_seleccionados;
        let disponibles = res.listaTotal;
        disponibles.forEach((item, index) => {
          this.listaAsignadosConocimientos.forEach((i) => {
            if (i.des_referencia === item.des_referencia) {
              disponibles.splice(index, 1);
            }
          })
        });
        this.listaDisponiblesConocimientos = disponibles;
      },
      (err: any) => {
      }
    )
  }

  getListaHabilidades() {
    let data ={
      candidato_id : this.idCandidato
    }
    this.coreService.getWithParams('/index-habilidades', data).subscribe(
      (res: any) => {
        this.listaAsignadosHabilidades = res.registros_seleccionados;
        let disponibles = res.listaTotal;
        disponibles.forEach((item, index) => {
          this.listaAsignadosHabilidades.forEach((i) => {
            if (i.des_referencia === item.des_referencia) {
              disponibles.splice(index, 1);
            }
          })
        });
        this.listaDisponiblesHabilidades = disponibles;
      },
      (err: any) => {
      }
    )
  }

}
